export default __webpack_public_path__ + "static/media/Banner_EPL2.0b574095.png";